import styled from 'styled-components'

import { colors } from '../../../../styles/colors'

const PrimaryStrong = styled.strong`
	// color: ${colors.lightPrimary};
`

export default PrimaryStrong
